import { memo } from "react";

const UploadRejected = () => (
  <svg width="57" height="53" viewBox="0 0 57 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="14" r="14" fill="#C55353" fillOpacity="0.1" />
    <circle cx="52.5" cy="47.5" r="4.5" fill="#C55353" fillOpacity="0.1" />
    <g transform="translate(11, 11)">
      <path d="M42 0H0V42H42V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M21 38.5C30.665 38.5 38.5 30.665 38.5 21C38.5 11.335 30.665 3.5 21 3.5C11.335 3.5 3.5 11.335 3.5 21C3.5 30.665 11.335 38.5 21 38.5Z"
        fill="#C55353"
      />
      <path
        d="M25.9493 16.0501L16.0498 25.9496"
        stroke="white"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0498 16.0501L25.9493 25.9496"
        stroke="white"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default memo(UploadRejected);
